import { EnvironmentContextState, EnvironmentProviderProps } from './EnvironmentContext.types'
import { createContext } from 'react'

export const EnvironmentContext = createContext<EnvironmentContextState>({} as EnvironmentContextState)

export const EnvironmentProvider = ({ config, children }: EnvironmentProviderProps) => {
    return <EnvironmentContext.Provider value={{ config }}>
        {children}
    </EnvironmentContext.Provider>
}